import { type FunctionComponent, useState } from "react";

/* eslint-disable no-control-regex */
const NEWLINE_LIMIT = 20;

export const StringValue: FunctionComponent<{
	string: string;
	shallow: boolean;
}> = ({ string, shallow }) => {
	//
	// Largely inspired by `formatString.js`.
	//

	const [expanded, setExpanded] = useState(false);

	if (!shallow) {
		// String has fewer escapes displayed with double quotes
		if (count(string, /["\n]/g) <= count(string, /`|\${/g)) {
			return <span className="text-syntax-string">{JSON.stringify(string)}</span>;
		}

		const lines = string.split("\n");
		if (lines.length > NEWLINE_LIMIT && !expanded) {
			const truncatedCount = lines.length - NEWLINE_LIMIT;

			return (
				<div>
					<span className="text-syntax-string">
						{"`" + templatify(lines.slice(0, NEWLINE_LIMIT).join("\n"))}
					</span>
					<button
						className={`cursor-pointer text-xs italic`}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
							setExpanded(true);
						}}
					>
						{`Show more ↓ (${truncatedCount} truncated line${
							truncatedCount > 1 ? "s" : ""
						})`}
					</button>
				</div>
			);
		}
		return <span className="text-syntax-string">{"`" + templatify(string) + "`"}</span>;
	}

	return (
		<span className="text-syntax-string">
			{JSON.stringify(
				string.length > 100 ? `${string.slice(0, 50)}…${string.slice(-49)}` : string
			)}
		</span>
	);
};

function templatify(string: string) {
	return string.replace(/[\\`\x00-\x09\x0b-\x19]|\${/g, templatifyChar);
}

function templatifyChar(char: string) {
	const code = char.charCodeAt(0);
	switch (code) {
		case 0x8:
			return "\\b";
		case 0x9:
			return "\\t";
		case 0xb:
			return "\\v";
		case 0xc:
			return "\\f";
		case 0xd:
			return "\\r";
	}
	let templated = "\\" + char;
	if (code < 0x10) {
		templated = "\\x0" + code.toString(16);
	} else if (code < 0x20) {
		templated = "\\x" + code.toString(16);
	}
	return templated;
}

function count(string: string, re: RegExp) {
	let n = 0;
	while (re.exec(string)) {
		++n;
	}
	return n;
}
